// extracted by mini-css-extract-plugin
export default {"avatar":"uVxoc9Prp271uQbbj699"};